<template>
  <div v-if="artists.length > 0" class="filter-wrapper">
    <div
      v-for="artist in artists"
      v-bind:key="'featured-artist-filter-' + artist.handle"
      class="filter-button"
    >
      <base-button @click="onClick(artist.handle)" type="secondary" size="sm">@{{artist.handle}}</base-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "featured-artists-filter",
  props: {
    artists: {
      type: Array,
      default: () => [],
      description: "Array of featured artists"
    },
    onClick: {
      type: Function,
      description: "Callback function for button click"
    }
  }
};
</script>

<style scoped lang="scss">
.filter-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem 1rem 1rem 1rem;
  background-color: #f7f7f7;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;

  .filter-button {
    padding: 0 0.5rem 1rem;
  }
}
</style>